import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import configureStore from './store';
import reportWebVitals from './reportWebVitals';
import './assets/styles/styles.scss'
import 'aos/dist/aos.css';

export const history = createBrowserHistory();
const store = configureStore(history);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <HelmetProvider>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </HelmetProvider>
  </Provider>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
